import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import AboutOwnerMini from '../AboutOwner/AboutOwnerMini';
import PageListMini from '../PageList/PageListMini';
import PageSection from '../PageSection/PageSection';

interface CampaignMini {
  totalCount: number;
  campaigns: {
    id: string;
    title: string;
    logo?: string | null;
    summary?: string | null;
    url: string;
    branding?: {
      logo: string | null;
    };
  }[];
  charityRegistrationNumber?: string;
  charityShortName?: string;
  charityName?: string;
}

const CampaignMini: FunctionComponent<CampaignMini> = ({
  totalCount,
  campaigns,
  charityName,
  charityRegistrationNumber,
  charityShortName,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  if (totalCount === 1) {
    const [{ url, logo, title, summary, branding }] = campaigns;
    return (
      <AboutOwnerMini
        ownerUrl={url}
        logo={branding?.logo ?? logo}
        name={title}
        description={summary}
        registrationNumber={charityRegistrationNumber}
        parentOwnerUrl={charityShortName ? `/${charityShortName}` : undefined}
        parentOwnerName={charityName}
      />
    );
  }

  return (
    <PageSection
      title={t('page.campaignMiniTitle')}
      className="jg-pages-aboutownermini"
      count={totalCount}
    >
      <PageListMini pages={campaigns} totalCount={totalCount} />
    </PageSection>
  );
};

export default CampaignMini;
